module.exports = __webpack_public_path__ + "img/CautionGray.c965020d.png";